<template>
    <div class="body">
        <div class="topStick">
            <div class="tip">{{studentName}} {{idCard}}
                <!-- <span class="tipText">待缴费</span> -->
            </div>
        </div>
        <van-empty description="暂无待缴费账单" v-if="list.length==0"/>
        <div class="box" v-for="(detailObj,index) in list" :key="index">
            <div class="title">
                <div class="title-l">
                    截止日期:{{detailObj.endTime}}
                </div>
                <div class="title-r red">待支付</div>
            </div>
            <div>
                <div class="details">
                    <div class="details-name">
                        <div>{{detailObj.title}}</div>
                        <div class="majorIngredient">{{detailObj.remark}}</div>
                    </div>
                    <div class="details-r">
                        <div>￥{{detailObj.payableAmount}}</div>
                    </div>
                </div>
            </div>
            <div class="priceDetail">
                <span v-if="detailObj.payedAmount">累计缴费 ￥{{detailObj.payedAmount}}</span>
                <span v-if="detailObj.refundedAmount" class="gray">累计退费 ￥{{detailObj.refundedAmount}}</span>
            </div>
            <div class="content">
                <div class="content-l">
                    <div>账单号: {{detailObj.studentBillDetailId}}</div>
                    <div>截止时间: {{detailObj.endTime}}</div>
                </div>
                <div class="content-2" @click="detailJump(detailObj)">
                    去缴费
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Vant from 'vant';

    export default {
        name: "studentBill",
        data() {
            return {
                active: 0,
                list: [],
                idCard: '',
                studentName: '',
                appId:'',
            }
        },
        created() {
            this.idCard = localStorage.getItem('idCard')
            this.appId = localStorage.getItem('appId')
            this.getList()

        },
        mounted() {
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');
            this.appId=localStorage.getItem('appId')||''
            if (code) {
                this.getOpenId(code)
            }

        },
        methods: {
            getOpenId(code) {
                let _this = this
                let url = '/zuhu1/api-dashboard/orderCenter/wx_bill_op'
                let query = {
                    code: code,
                    appid: _this.appId,
                }
                this.$api.post(url, query, function (result) {
                    let openid = result.data.data || localStorage.getItem('openid')
                    localStorage.setItem('openid', openid)
                })
            },
            getList() {
                let _this = this
                let url = '/zuhu1/api-dashboard/studentBill/search'
                let query = {
                    idCard: this.idCard
                }
                this.$api.post(url, query, function (result) {
                    let list = result.data.data || []
                    let arr = []
                    list.map(item => {
                        item.ctnTrue = item.cnt - item.payedCnt || 0

                        if ((item.payedAmount - item.refundedAmount) < item.payableAmount) {
                            arr.push(item)
                        }
                    })
                    _this.studentName = result.data.studentName || ''
                    _this.list = arr
                })
            },
            detailJump(item) {

                if (item.orderCenters) {
                    this.$router.push({
                        name: 'studentBillDetail',
                        params: {detail: item, studentName: this.studentName}
                    })
                } else {
                    this.$router.push({
                        name: 'studentBillDetailWx',
                        params: {detail: item, studentName: this.studentName}
                    })
                }

            },

        }
    }
</script>

<style scoped>
    .body {
        background: rgb(248, 248, 249);
    }

    .sticky {
        position: sticky;
        top: 0;
        z-index: 999;
    }

    .box {
        background: white;
        width: 94%;
        margin: 10px auto;
        border-radius: 5px;
        padding: 10px 0;
        box-sizing: border-box;
        font-size: 16px;
    }

    .title {
        display: flex;
        font-size: 16px;
        width: 100%;
        border-bottom: 1px solid rgba(153, 153, 153, 0.4);
        height: 40px;
        line-height: 35px;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .title-l {
        flex: 1;
        color: #0C0D0D;
    }

    .title-r {
        color: #7D7C7C;
        padding: 0 5px;
    }

    .content {
        color: #7D7C7C;
        font-size: 12px;
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
    }

    .content-l {
        flex: 1;
    }

    .content-l > div {
        padding: 2px 0;
    }

    .content-r {
        width: 50px;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: black;
    }

    .details {
        display: flex;
        padding: 8px 10px;
    }

    .details-name {
        flex: 1;
        padding-left: 10px;
    }

    .details-r {
        font-size: 14px;
        color: #101010;
        display: flex;
        align-items: center;
    }

    .num {
        color: #999999;
        text-align: right;
        font-size: 12px;
    }

    .majorIngredient {
        font-size: 14px;
        padding: 13px 0;
        color: #999999;
    }

    .foods {
        display: flex;
    }

    .foods-l {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
    }

    .foods-l > div {
        width: 80px;
        margin: 0 8px 8px 0;
    }

    .foods-r {
        width: 50px;
        text-align: right;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 8px;
    }

    .food-name {
        font-size: 12px;
        color: #A6A4A4;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .food-num {
        font-size: 13px;
        color: #7D7C7C;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .foot {
        padding: 0 10px 0;
        text-align: right;
    }

    .btn {
        display: inline-block;
        color: #615D64;
        background: #F5F5F5;
        width: 75px;
        height: 27px;
        line-height: 27px;
        text-align: center;
        font-size: 12px;
        border: 1px solid rgba(218, 218, 218, 0.6);
        border-radius: 5px;
    }

    .grey {
        color: #BBBBBB;
    }

    .red {
        color: #EA0909;
    }

    .green {
        color: #3CC878;
    }

    .content-2 {
        height: 27px;
        line-height: 27px;
        border-radius: 6px;
        background-color: rgba(255, 152, 0, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 12px;
        text-align: center;
        width: 76px;
    }

    .blue {
        background: #2D8CF0 !important;
    }

    .topStick {
        position: sticky;
        top: 0;
        background: white;

    }

    .priceDetail {
        font-size: 14px;
        padding: 13px 0;
        color: #098288;
        text-align: right;
    }

    .priceDetail span {
        padding-left: 10px;
    }

    .priceDetail .gray {
        color: #999999;
    }

    .tip {
        color: #101010;
        height: 40px;
        line-height: 40px;
        padding: 5px 20px;
    }

    .tipText {
        color: black;
        float: right;
        font-weight: bold;
        font-size: 18px;
    }
</style>
